import React from 'react';
import { cn } from '../../utils/cn';

interface SlideTransitionProps {
  isActive: boolean;
  isPrevious: boolean;
  children: React.ReactNode;
}

const SlideTransition = ({ isActive, isPrevious, children }: SlideTransitionProps) => {
  return (
    <div
      className={cn(
        "absolute inset-0 transition-transform duration-700 ease-in-out",
        isActive ? "z-20 translate-x-0" : "z-10",
        !isActive && isPrevious ? "-translate-x-full" : "translate-x-full",
        "before:absolute before:inset-0 before:z-10 before:transition-opacity before:duration-700",
        isActive ? "before:opacity-0" : "before:opacity-100"
      )}
    >
      {children}
    </div>
  );
};

export default SlideTransition;